var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tabPage",class:['tab-pane', 'tab-page', { 'active': _vm.active }],attrs:{"role":"tabpanel","id":_vm.tabIdentifier,"data-tab-id":_vm.tabid}},[_c('div',{staticClass:"panel-body"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }